import styled from '@emotion/styled';
import FormField from 'components/FormField';
import HintInput from 'components/HintInput';
import { useTranslate } from '@tolgee/react';
import { FV } from './share';

const NameInput = styled(HintInput)`
  width: 340px;
`;

const nameLimitLength = 30;

function NameField({ disabled = false }: { disabled?: boolean }) {
  const { t } = useTranslate();

  return (
    <FormField<FV['taskName']>
      required
      name="taskName"
      label={t('marketing.任务名称')}
      validate={(value) => {
        if (!value || !value.trim()) {
          return t('marketing.请输入任务名称');
        }

        if (value.length > nameLimitLength) {
          return t('marketing.任务名称不得超过x个字', { x: nameLimitLength });
        }

        return undefined;
      }}
    >
      {({ field }) => {
        return (
          <NameInput
            disabled={disabled}
            allowClear
            limit={nameLimitLength}
            maxLength={nameLimitLength}
            placeholder={t('marketing.请输入任务名称')}
            {...field}
          />
        );
      }}
    </FormField>
  );
}

export default NameField;
